import './LoginPageStyle.css';
import NavBar from './NavBar';
import { useEffect, useState } from 'react';
import EpimsLogoOnly from './components/EpimsLogoOnly';
import { useLocation, useNavigate } from 'react-router-dom';


function LoginPage(props) {

  const location = useLocation()
  const navigate = useNavigate()

  const [username, setUsername] = useState(location?.state?.username ?? "")
  const postSignup = (location?.state?.postSignup ?? false)
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")
  const [loginButtonDisabled, setLoginButtonDisabled] = useState(false)
  const [tooManyFailedLogins, setTooManyFailedLogins] = useState(false)

  const [contactMethod, setContactMethod] = useState('')
  const [contactMessage, setContactMessage] = useState('')

  const [contactButtonDisabled, setContactButtonDisabled] = useState('')
  const [contactSubmitted, setContactSubmitted] = useState(false)

  const doLogin = (event) => {
    setLoginButtonDisabled(true)
    setTooManyFailedLogins(false)
    setError("Wait...");
    const url = process.env.REACT_APP_API_END_POINT + 'login';
    fetch(url,
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: "POST",
        body: JSON.stringify({
          username,
          password
        }),
        credentials: "include"
      })
      .then((resp) => resp.json())
      .then((data) => {
        setLoginButtonDisabled(false);
        setError('')
        if (data['success']) {
          props.setIsLoggedIn(true);
          props.setUserRole(data['role']);
          props.setUserRealName(data['name']);
          navigate('/start');
        } else {
          if (data['error'] === 'TOO_MANY_FAILED') {
            setTooManyFailedLogins(true)
          } else {
            setError(data['error']);
          }
        }
      });
    event.preventDefault();
  }

  const doContact = (event) => {
    setContactButtonDisabled(true)
    const url = process.env.REACT_APP_API_END_POINT + 'contactform';
    fetch(url, {
        headers: {
            'Accept': 'application/json',
        },
        method: "POST",
        credentials: "include",
        body: JSON.stringify({
          subject: 'ha',
          contactMethod,
          message: contactMessage
        })
    })
    .then((resp) => resp.json())
    .then((data) => {
        setContactButtonDisabled(false)
        setContactSubmitted(true)
    });
    event.preventDefault()
  }

  const navigateForgotPassword = (event) => {
    navigate('/forgotpassword');
    event.preventDefault();
  }

  useEffect(() => {
    if (props.isLoggedIn) {
      navigate('/home');
    } else {
      window.scrollTo(0, 0)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const signupUrl = 'https://' + process.env.REACT_APP_WWW_BASE_DOMAIN + '/assessors/'
  const signupUrlPropertyProfessionals = 'https://' + process.env.REACT_APP_WWW_BASE_DOMAIN + '/property-professionals/'

  return (
    <>
      <NavBar />
      <div className="login-page-container">

        <div className="assessors-heading"><span style={{verticalAlign: "4px"}}><EpimsLogoOnly xxsmall /></span> for Property Professionals</div>

        <div className= "login-container">

          <div className="inset-image login-image"></div>

          <div className="login-left">

              <div className="login-title">Now theres a completely free and easy way to:</div>
              <ul className="checkList">
                <li>Increase your revenue by &pound;1000&apos;s.</li>
                <li>Convert old EPCs to income.</li>
                <li>Offer your customers more to help them on their energy saving retrofit journey.</li>
                <li>Maximise the value of your skill and experience.</li>
                <li>No sign up fees, no contracts.</li>
              </ul>
              <p className="cta">Get started today, no payment required (ever). To arrange a FREE demonstration contact Ross Hopgood, ross@epims.co.uk or call&nbsp;0161&nbsp;832&nbsp;3280.</p>
          </div>
          <div className="login-right">
            { postSignup && (
              <div className="login-message">
                <p>Thank you for registering with epIMS! Please login below to begin</p>
              </div>
            )}
            <div className="card form-style">
              <div className="card-header mobile-center" ><strong>Login to your epIMS account</strong></div>
              <div className="card-body">
                <form onSubmit={doLogin}>
                  <div className="form-group pb-2">
                    <label htmlFor="usernameInput" className="pb-1">Username (email)</label>
                    <input id="usernameInput" className="form-control" type="text" placeholder="Username" value={username} onChange={e => setUsername(e.target.value)} />
                  </div>
      
                  <div className="form-group pb-2">
                    <label htmlFor="passwordInput" className="pb-1">Password</label>
                    <input id="passwordInput" className="form-control" type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} />
                  </div>
      
                  <div className="form-group mobile-center">
                    <button type="submit" disabled={loginButtonDisabled} className="btn btn-primary btn-sm">Login</button>&nbsp;<span>{error}</span>
                  </div>
      
                  {tooManyFailedLogins && 
                    <div className="form-group mobile-center">
                      <p className="my-2">Please wait 30 minutes before trying to login again. If you have forgotten your password, reset it <a href="/forgotpassword" onClick={navigateForgotPassword}>here</a>.</p>
                    </div>
                  }

                  <div className="form-group pt-1 mobile-center">
                    <span><a href="/forgotpassword" onClick={navigateForgotPassword}>Forgot password?</a></span>
                  </div>
                </form>
              </div>
      
              <div className="card-footer">
                <strong>Don't have an account?</strong><br/>Property Professionals: <a id="propertyProfessionalsSignupLink" href={signupUrlPropertyProfessionals}>Sign up here</a><br/>Energy Assessors: <a id="assessorsSignupLink" href={signupUrl}>Sign up here</a>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="assessors-heading"><span style={{verticalAlign: "4px"}}><EpimsLogoOnly xxsmall /></span> for local authorities and financial institutions</div> */}
        <div className="assessors-heading"><span style={{verticalAlign: "4px"}}><EpimsLogoOnly xxsmall /></span> for Local Authorities and Financial Institutions</div>
        <div className= "login-container mobile-reverse">
          <div className="inset-image housing-image"></div>
          <div className="login-left">
            <p>epIMS is a powerful platform designed to support local authorities and banks in delivering accurate, targeted advice. By mapping your housing stock and portfolio at street, area, or regional levels, epIMS helps you better understand your assets and engage the public more effectively.</p>
            <p>The platform integrates EPC data with external datasets and links to:</p>
            <ul className="checkList">
              <li>Available grant funding</li>
              <li>Budget costings</li>
              <li>Tailored recommendations</li>
              <li>Actionable support to property improvements</li>
            </ul>
            <p>Whether you&apos;re aiming to accelerate advice distribution or guide clients on clear, practical steps to enhance energy efficiency, epIMS streamlines the process and can easily integrate into your existing systems allowing you to provide retrofit advice affordably and at scale.</p>
            <p><strong>Contact us today</strong> to learn how epIMS can transform your approach to the retrofit market.</p>
          </div>
          <div className="login-right">
            {!contactSubmitted ? <>
              <div className="card form-style">
                <div className="card-header mobile-center" ><strong>Contact epIMS</strong></div>
                <div className="card-body">
                  <form onSubmit={doContact}>
                    <div className="form-group pb-2">
                      <label htmlFor="contactMethodInput" className="pb-1">Email or phone number:</label>
                      <input id="contactMethodInput" className="form-control" type="text" placeholder="Your email address or phone number" value={contactMethod} onChange={e => setContactMethod(e.target.value)} />
                    </div>
        
                    <div className="form-group pb-2">
                      <label htmlFor="contactMessageInput" className="pb-1">Message:</label>
                      <textarea style={{height: "120px"}} id="contactMessageInput" className="form-control" type="textarea" value={contactMessage} onChange={e => setContactMessage(e.target.value)}></textarea>
                    </div>
        
                    <div className="form-group mobile-center">
                      <button type="submit" disabled={contactButtonDisabled} className="btn btn-primary btn-sm">Submit</button>
                    </div>

                  </form>
                </div>
              </div>
            </> : <>
              <div>
                <p className="thankYouMessage">Thank you for contacting epIMS, we will be in touch in the next 48 hours.</p>
              </div>
            </> }
          </div>
        </div>
        <div className="working-with-banner">
          <p>WORKING WITH</p>
          <img alt="Dwell Developments Limited Logo" src="/banner_graphics/dwell.png" />
          <img alt="Elmhurst Energy Logo" src="/banner_graphics/elmhurst.png" />
          <img alt="EPC Choice Logo" src="/banner_graphics/epcchoice.png" />
          <img alt="Heat Pump Central Logo" src="/banner_graphics/heatpumpcentral.png" />
          <img alt="Joseph Thomas Group Logo" src="/banner_graphics/josephthomas.png" />
          <img alt="Peak and Penning Properties Limited Logo" src="/banner_graphics/peakandpennine.png" />
          <img alt="Thomas Halliwell Logo" src="/banner_graphics/thomashalliwell.png" />
          <img alt="Trustmark Logo" src="/banner_graphics/trustmark.png" />
          <img alt="UK GBC Logo" src="/banner_graphics/ukgbc.png" />
        </div>
        <div className="epa-logo-container">
          <a href={"https://" + process.env.REACT_APP_WWW_BASE_DOMAIN + "/"}><img alt="epIMS is an EPA (Energy Performance Advice) company - Patent Pending" src="/epims_epa.png" /></a>
        </div>
      </div>
    </>
  );


}

export default LoginPage;